<template>
  <router-link :to="to">
    <div class="application-block">
      <div 
        v-if="addbutton"
        class="application-block--add"
      >
        <AddIcon/>
      </div>

      <div v-if="!addbutton">
        <ObjectFit
          v-if="iconsrc !== ''"
          class="app-icon"
          :src="iconsrc"
          :title="icontitle"
          :alt="iconalt"
        />

        <div
          v-else
          class="app-icon"
        >
          <p>{{ firstLettersOfName() }}</p>
        </div>
        
        <h3>{{ title }}</h3>

        <p>{{ subtitle }}</p>
        
        <!-- <img
          src="../../assets/flagNL.jpg"
          alt="flag"
          title="flag"
          class="application-block--flag"
        /> -->

        <p>{{ lang }}</p>

        <p v-if="date !== ''">Live date: {{ showDate(date) }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
  import ObjectFit from '../images/objectFit.vue'
  import AddIcon from '../../icons/add.vue'
  import moment from 'moment';

  export default {
    name: 'ApplicationBlock',
    components: {
      ObjectFit,
      AddIcon
    },
    props: [
      'to',
      'iconsrc',
      'icontitle',
      'iconalt',
      'title',
      'subtitle',
      'lang',
      'date',
      'addbutton'
    ],
    methods: {
      showDate: function(date) {
        const dateString = moment.utc(date, 'YYYY-MM-DD').format('D MMMM YYYY');
        return dateString;
      },
      firstLettersOfName: function() {
        const matches = this.title.match(/\b(\w)/g);
        const joinMatches = matches.join('');

        return joinMatches;
      }
    }
  }
</script>

<style lang="scss">
  .application-block {
    background-color: var(--white);
    border-radius: 3px;
    transition: 0.2s;    
    margin-bottom: 15px;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    height: 154px;
    
    &:hover {
      filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.05));
    }

    &--add {
      background-color: var(--blue);
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      margin: auto;
      top: 0;
      right: 0;      
      bottom: 0;
      left: 0;
    }

    .app-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      margin: auto;
      margin-bottom: 5px;
      margin-top: 10px;
      background-color: var(--blue);
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        color: var(--white);
        font-weight: bold;
        font-size: 11px;
      }
    }

    h3,
    p {
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 12px;
    }

    &--flag {
      width: 16px;
      height: 10px;
      margin: auto;
      display: block;
      margin-top: 10px;
    }
  }
</style>